import { render, staticRenderFns } from "./W9V1.vue?vue&type=template&id=36a3b654&scoped=true&"
import script from "./W9V1.vue?vue&type=script&lang=js&"
export * from "./W9V1.vue?vue&type=script&lang=js&"
import style0 from "./W9V1.vue?vue&type=style&index=0&id=36a3b654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a3b654",
  null
  
)

export default component.exports